<div class="p-3">
    <div class="row">
        <div class="col-sm-3 col-md-3">
            <div>
                <div class="card">
                    <div class="position-relative">
                        <div class="position-absolute top-0 end-0">
                            <div class="m-2">
                                <input #csvInput hidden="true" type="file" onclick="this.value=null"
                                    (change)="csvInputChange($event)" accept="image/png, image/jpeg" />
                                <!-- <button mat-flat-button color="primary" (click)="csvInput.click()">Choose Spreadsheet
                                    File (CSV)</button> -->
                                <mat-icon aria-hidden="false" aria-label="Example home icon"
                                    [ngStyle]="{'color':'#3f51b5'}" fontIcon="create" (click)="csvInput.click()"></mat-icon>
                            </div>
                        </div>
                        <ng-container *ngIf="updateImgflag">
                            <div class="position-absolute top-50 start-50 translate-middle">
                                <button mat-flat-button class="update_button" color="primary" traslate>update</button>
                            </div>
                        </ng-container>
                        <img #img [src]='imageUrl' (error)="img.src = onerror" class="card-img-top"
                            alt="...">
                        <div class="card-body bg-profile-blue">
                            <div class="position-relative">
                                <div class="card-text text-center text-white">
                                    <div>
                                        <h4 class="m-0"><strong>{{studentData?.first_name}}
                                                {{studentData?.last_name}}</strong></h4>
                                    </div>
                                    <div>
                                        <p class="m-0"><span translate>Course</span>: {{studentData?.course_name}}</p>
                                    </div>
                                    <div>
                                        <p class="m-0"><span translate>Roll.No</span>: {{studentprofile?.roll_number}}</p>
                                    </div>
                                    <div>
                                        <p class="m-0"><span translate>Semister</span>: {{studentprofile?.semister}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-9 col-md-9">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab label="{{Personal | translatepipe}}">
                    <div class="mt-4">
                        <div class="row m-0">
                            <div class="col-md-6">
                                <div>
                                    <p><strong> <span translate>Hallticket Number</span> : </strong><span>{{studentprofile?.hallTicket_number}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Gender</span> : </strong><span>{{studentprofile?.gender}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Date of Birth</span>: </strong><span>{{studentprofile?.date_of_birth}}</span>
                                    </p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Aadhar</span> : </strong><span>{{studentprofile?.adhar_number}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Contact</span> : </strong><span>{{studentData?.phone_number}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Email Id</span> : </strong><span>{{studentData?.email}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Caste</span> : </strong><span>{{studentData?.personal_details.caste}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>SubCaste</span> : </strong><span>{{studentData?.personal_details.sub_caste}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Present Address</span> : </strong><span *ngIf="studentaddress?.length>0">{{studentaddress[0]?.address_line1}},{{studentaddress[0]?.address_line2}}, {{studentaddress[0]?.city}}, {{studentaddress[0]?.state_name}}, {{studentaddress[0]?.country_name}}, {{studentaddress[0]?.pincode}}</span></p>
                                </div>
                                <div>
                                    <p><strong> <span translate>Permanent Address</span> : </strong><span *ngIf="studentaddress?.length>0">{{studentaddress[1]?.address_line1}},{{studentaddress[1]?.address_line2}}, {{studentaddress[1]?.city}}, {{studentaddress[1]?.state_name}}, {{studentaddress[1]?.country_name}}, {{studentaddress[1]?.pincode}}</span></p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div>
                                    <p><strong translate> Future Goal : </strong><span>{{studentprofile?.future_goal}}</span></p>
                                </div>
                                <div>
                                    <p><strong translate> Extra Curricular Activities :
                                        </strong><span>{{studentprofile?.interested_extra_activities}}</span></p>
                                </div>
                                <div>
                                    <p><strong translate> Participation in NCC/NSS :
                                        </strong><span>{{studentprofile?.participation_in_ncc_nss}}</span></p>
                                </div>
                                <div>
                                    <p><strong translate> Participation in Sports/Games :
                                        </strong><span>{{studentprofile?.participation_in_sports_games}}</span></p>
                                </div>
                                <div>
                                    <p><strong translate> Hobbies : </strong><span>{{studentprofile?.hobbies}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="{{Education | translatepipe}}">
                    <div class="mt-4">
                        <div class="row m-0" *ngIf="studenteducation?.length > 0; else nodata">
                            <div class="col-md-6 mb-3" *ngFor="let education of studenteducation">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">{{education?.qualification}}</h5>
                                        <div class="card-text">
                                            <div>
                                                <p><strong translate>Inter Stream :
                                                    </strong><span>{{education?.course_name}}</span></p>
                                            </div>
                                            <div>
                                                <p><strong translate>Marks : </strong><span>{{education?.percentage}}</span></p>
                                            </div>
                                            <div>
                                                <p><strong translate>Year of Pass : </strong><span>{{education?.end_year | date: 'dd/MM/yyyy'}}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #nodata>
                            <h4 translate>No Data</h4>
                        </ng-template>
                    </div>
                </mat-tab>
                <mat-tab label="{{Family | translatepipe}}">
                    <div class="mt-4">
                        <div class="row m-0">
                            <div class="col-md-12">
                                <p><strong translate>Father’s Name : </strong><span>{{studentfamily?.fathers_name}}</span></p>
                            </div>
                            <div class="col-md-12">
                                <p><strong translate> Father's Occupation :
                                    </strong><span>{{studentfamily?.fathers_occupation}}</span></p>
                            </div>
                            <div class="col-md-12">
                                <p><strong translate> Mother's Name : </strong><span>{{studentfamily?.mothers_name}}</span></p>
                            </div>
                            <div class="col-md-12">
                                <p><strong translate> Mother's Occupation :
                                    </strong><span>{{studentfamily?.mothers_occupation}}</span></p>
                            </div>
                            <div class="mt-5">                                
                                <div class="col-md-12">
                                    <p><strong translate> Number of Brothers :</strong><span>{{studentfamily?.number_of_brothers}}</span></p>
                                </div>
                                <div class="col-md-12">
                                    <p><strong translate> Number of Sisters :</strong><span>{{studentfamily?.number_of_sisters}}</span></p>
                                </div>
                            <div class="col-md-12">
                                <p><strong translate> Annual Income :</strong><span>{{studentfamily?.annual_income}}</span></p>
                            </div>
                            <div class="col-md-12">
                                <p><strong translate> Parents Contact Number :
                                    </strong><span>{{studentfamily?.parent_contact_number}}</span></p>
                            </div>
                        </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>